import { DZ_COLOR_NEUTRAL_400 } from '@blk/daisy/core/styles';
import { AbstractRenderer, Alignment, BusinessComponent, BusinessComponentOptions, ColumnPanel, ImageRenderer, RowPanel, StaticParagraphComponent } from '@blk/simba';
import { InjectConfig, ModelsExperienceConfigKey } from '@ddt-web/config-layer';
import { SvgImage } from '@ddt-web/pdf-components';

import { EsgRatingMapping } from '../../models';

export class EsgMsciRatingsComponent extends BusinessComponent {
	@InjectConfig(ModelsExperienceConfigKey.ESG_RATING_MAPPING) public readonly esgRatingsMapping: Array<EsgRatingMapping> = [];

	constructor(name: string, public visible: boolean = true) {
		super(name, 'BusinessComponent', BusinessComponentOptions.merge({ visible: visible }));
	}

	public buildComponent(): AbstractRenderer<SVGGElement>[] {
		const panels: AbstractRenderer<SVGGElement>[] = [];

		panels.push(
			...[
				new RowPanel(
					'Esg Msci Ratings',
					[
						new ColumnPanel(
							'Esg Ratings Table',
							[this.buildHeaderRow(), ...this.buildRatingRows()],
							{ proportion: 60 },
							Alignment.Horizontal.Left,
							Alignment.Vertical.Top
						),
						new ColumnPanel('', [], { proportion: 40 }, Alignment.Horizontal.Left, Alignment.Vertical.Top)
					],
					{ marginBottom: 30, borderBottom: 0.5, borderBottomColor: DZ_COLOR_NEUTRAL_400 }
				)
			]
		);

		return panels;
	}

	private buildHeaderRow(): RowPanel {
		return new RowPanel(
			'Esg Ratings Header',
			[
				new ColumnPanel(
					'MSCI Esg Ratings',
					[new StaticParagraphComponent('MSCI_ESG_RATING_HEADER_LABEL_PDF', 'MSCI ESG RATING', {}, {}, ['text-bold', 'text-10'])],
					{ proportion: 22 },
					Alignment.Horizontal.Left,
					Alignment.Vertical.Top
				),
				new ColumnPanel(
					'Esg Category',
					[new StaticParagraphComponent('MSCI_ESG_RATING_SUB_HEADER_PDF', 'CCC(worst) to AAA(best)', {}, {}, ['text-10'])],
					{ proportion: 53 },
					Alignment.Horizontal.Left,
					Alignment.Vertical.Top
				),
				new ColumnPanel(
					'Esg Category',
					[new StaticParagraphComponent('MSCI_ESG_RATING_CATEGORY_LABEL_PDF', 'ESG Category', {}, {}, ['text-bold', 'text-10'])],
					{ proportion: 25 },
					Alignment.Horizontal.Left,
					Alignment.Vertical.Top
				)
			],
			{ marginBottom: 10, borderBottom: 0.5, borderBottomColor: DZ_COLOR_NEUTRAL_400 },
			Alignment.Horizontal.Left,
			Alignment.Vertical.Top
		);
	}

	private buildRatingRows(): RowPanel[] {
		return this.esgRatingsMapping.map((esgMapping, index) => {
			return new RowPanel(
				`Esg Rating ${index}`,
				[
					new ColumnPanel(
						'Low',
						[new StaticParagraphComponent('', esgMapping.low, {}, {}, ['text-10'])],
						{ proportion: 20 },
						Alignment.Horizontal.Left,
						Alignment.Vertical.Top
					),
					new ColumnPanel(
						'High',
						[new StaticParagraphComponent('', esgMapping.high, {}, {}, ['text-10'])],
						{ proportion: 20 },
						Alignment.Horizontal.Left,
						Alignment.Vertical.Top
					),
					new ColumnPanel(
						'Arrow',
						[new ImageRenderer(new SvgImage('ARROW_RIGHT').getStaticContent())],
						{ proportion: 35 },
						Alignment.Horizontal.Left,
						Alignment.Vertical.Bottom
					),
					new ColumnPanel(
						'Category',
						[new StaticParagraphComponent('', esgMapping.category, {}, {}, ['text-10'])],
						{ proportion: 25 },
						Alignment.Horizontal.Left,
						Alignment.Vertical.Top
					)
				],
				{ marginBottom: 6 }
			);
		});
	}
}
